// GENERATE A NEW ID! 
function randomKey() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function get_date() {
    // DATE FOR COURS ONGOING
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd;}
        if (mm < 10) {mm = '0' + mm;}
        return  yyyy + '-' + mm + '-' + dd;
    }


function get_current_session_annee() {

var retSession = ''
    var mm = today.getMonth() + 1;
    switch(mm) {
        case mm < 5:
        retSession += "H-"
          break;
        case mm < 9:
            retSession += "E-"
          break;
        default:
            retSession += "A-"
      }
      var today = new Date();
      retSession += today.getFullYear().substring(2,4)
      return retSession
}



export default {randomKey, get_date, get_current_session_annee}